import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)
    
    return (
        <svg
            width={17}
            height={14}
            viewBox="0 0 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.344 3.875h9.375m0 0a2.344 2.344 0 104.687 0 2.344 2.344 0 00-4.687 0zm-4.688 6.25h9.375m-9.375 0a2.344 2.344 0 11-4.687 0 2.344 2.344 0 014.687 0z"
                stroke={props.isHover ? theme["#0D968F"] : '#A0A0A0'}
                strokeWidth={1.5625}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent